import React, { Component } from "react";
import IRClogs from "../irc-logs";
import SocialReddit from "../reddit";
import SocialTwitterWidget from "../twitter";
import "./index.css";
import SocialStats from "../social-stats";
import TauSocialWidget from "../tau-social-widget";

class SocialWidgets extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="social-feedback pt-2 pb-4">
          <img
            className="img-fluid"
            src={require("../../assets/icons/social-feeds-icon.svg")}
          />
          <span>Social Feed </span>
        </div>
        <IRClogs />
        <TauSocialWidget />
        <SocialReddit />
        <SocialTwitterWidget />
        <SocialStats />
      </React.Fragment>
    );
  }
}

export default SocialWidgets;
